import type * as React from 'react';
import { put } from '@Domain/Api';
import type { BeneficiaryListItemPayload } from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiariesFetched';
import beneficiaryArchived, {
	type BeneficiaryArchivedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryArchived';
import beneficiaryArchiveFailed, {
	type BeneficiaryArchiveFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryArchiveFailed';
import type ArchiveBeneficiary from '@Application/Beneficiaries/Beneficiaries/Commands/ArchiveBeneficiary';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryArchivedAction | BeneficiaryArchiveFailedAction;

export default (command: ArchiveBeneficiary) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<BeneficiaryListItemPayload>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries/${command.beneficiaryId}/status`,
				command.toJSON(),
			);

			const action = beneficiaryArchived(payload, command.facilityId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryArchiveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
